<template>
  <div class="injury_page">
    <div class="assessment_header">
      <span class="assessment_header">伤病</span>
      <div class="tabs">
        <div
          class="tabs_item"
          :class="{ 'is-active': tabs === 'current' }"
          @click="tabs = 'current'"
        >
          当前伤病
        </div>
        <div
          class="tabs_item"
          :class="{ 'is-active': tabs === 'history' }"
          @click="tabs = 'history'"
        >
          历史伤病
        </div>
      </div>
    </div>
    <injuryCard
      v-if="injuryData[tabs]"
      :cardList="injuryData[tabs]"
    ></injuryCard>
    <div v-else>
      <cl-no-data style="height: 240px" />
    </div>
  </div>
</template>
  
<script>
import injuryCard from "./components/injury-card.vue";
export default {
  components: {
    injuryCard,
  },
  props: {
    injuryData: {
      type: Object,
      default: () => ({
        current: [],
        history: [],
      }),
    },
  },
  data() {
    return {
      tabs: "current",
    };
  },
};
</script>
  
<style lang="scss" scoped>
@import "../common-style.scss";
.injury_page {
  min-height: 300px;
}
</style>